let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("e0n0c")).then(() => parcelRequire('dH96e'));